import { UserType } from '../../enums/user/userType.enum';
import { NavItem } from '../../interface/nav_items/nav_items.interface';

export const NAV_ITEMS_CLIENT: NavItem[] = [
  {
    name: 'Gestion del Perfil',
    url: '/profile',
    iconComponent: { name: 'cil-user' },
    userType: UserType.CLIENT,
    children: [
      {
        name: 'Actualizar Perfil',
        url: '/profile',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Clientes - Modificacion',
      },
    ],
  },
  {
    name: 'Gestion de Cotizaciones',
    url: '/packages/quote',
    iconComponent: { name: 'cil-calculator' },
    userType: UserType.CLIENT,
    children: [
      {
        name: 'Ver Cotizaciones',
        url: '/packages/quote',
        icon: 'nav-icon-bullet',
        permissionGroup: [
          'Cotizaciones - Visualizacion',
          'Cotizaciones - Creacion',
          'Cotizaciones - Modificacion',
          'Cotizaciones - Autorizacion',
        ],
      },
    ],
  },
  {
    name: 'Gestion Reservaciones',
    url: '/packages/reservations',
    iconComponent: { name: 'cil-calendar' },
    userType: UserType.CLIENT,
    children: [
      {
        name: 'Mis Reservaciones',
        url: '/packages/reservations',
        icon: 'nav-icon-bullet',
        permissionGroup: ['Reservaciones - Visualizacion', 'Reservaciones - Modificacion'],
      },
    ],
  },
  {
    name: 'Pagos',
    url: '/clients/client-payments',
    iconComponent: { name: 'cil-credit-card' },
    userType: UserType.CLIENT,
    children: [
      {
        name: 'Mis Pagos',
        url: '/clients/client-payments',
        icon: 'nav-icon-bullet',
        permissionGroup: ['Pagos de Clientes - Visualizacion', 'Pagos de Clientes - Creacion'],
      },
    ],
  },
];
